import { Injectable } from '@angular/core';
declare let THREE: any;
import { CollisionService } from '../../../../services/collision/collision.service';

@Injectable()
export class CollideChecker {

    protected staticColliderCache: any;
    protected collided: any;

    constructor(
        private collisionSrvc: CollisionService
    ) {
        this.staticColliderCache = {};
        this.collided = null;
    }

    check(newPosition, staticObjcts, draggedObj) {

        var collide = this.collisionSrvc.isCollide(draggedObj, staticObjcts, {
            newPosition,
            staticColliderCache: this.staticColliderCache
        });

        this.collided = collide;

        return !collide;
    }

    clearState() {
        this.staticColliderCache = {};
    }

    getCollided() {
        return this.collided;
    }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/collide-checker.ts